import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { API_ROUTES } from "../utils/utils";

@Injectable()
export class TaxPeConfigurationService {
    constructor(
        private httpClient: HttpClient,
        @Inject('BASE_URL') private baseUrl: string
    ) { }

    getFunctionPe(
        tthis: any | undefined = undefined,
        callback: any | undefined = undefined,
        callbackError: any | undefined) {

        const url = this.baseUrl + API_ROUTES.API_TAX + '/functionPe';
        this.httpClient.get<any>(url).subscribe({
            next: (result) => {
                if (tthis && callback)
                    callback(tthis, result);
            },
            error: (error) => {
                callbackError(tthis, error);
            }
        });
    };

    getTypePe(
        tthis: any | undefined = undefined,
        callback: any | undefined = undefined,
        callbackError: any | undefined) {

        const url = this.baseUrl + API_ROUTES.API_TAX + '/TypePe';
        this.httpClient.get<any>(url).subscribe({
            next: (result) => {
                if (tthis && callback)
                    callback(tthis, result);
            },
            error: (error) => {
                callbackError(tthis, error);
            }
        });
    };

    getPeConfiguration(
        tthis: any | undefined = undefined,
        callback: any | undefined = undefined,
        callbackError: any | undefined) {

        const url = this.baseUrl + API_ROUTES.API_TAX + '/peConfiguration';
        this.httpClient.get<any>(url).subscribe({
            next: (result) => {
                if (tthis && callback)
                    callback(tthis, result);
            },
            error: (error) => {
                callbackError(tthis, error);
            }
        });
    };

    updatePeConfiguration(
        tthis: any | undefined = undefined,
        body: PeConfiguration,
        callback: any | undefined = undefined,
        callbackError: any | undefined) {

        const url = this.baseUrl + API_ROUTES.API_TAX + '/updatePeConfiguration';
        this.httpClient.post<any>(url, body).subscribe({
            next: (result) => {
                if (tthis && callback)
                    callback(tthis, result);
            },
            error: (error) => {
                callbackError(tthis, error);
            }
        });
    }

    getPeConfigurationHistory(
        tthis: any | undefined = undefined,
        callback: any | undefined = undefined,
        callbackError: any | undefined) {

        const url = this.baseUrl + API_ROUTES.API_TAX + '/peConfigurationHistory';
        this.httpClient.get<any>(url).subscribe({
            next: (result: PeConfigurationHistory) => {
                if (tthis && callback)
                    callback(tthis, result);
            },
            error: (error) => {
                callbackError(tthis, error);
            }
        });
    }

    getCurrencyReference(
        tthis: any | undefined = undefined,
        callback: any | undefined = undefined,
        callbackError: any | undefined) {

        const url = this.baseUrl + API_ROUTES.API_TAX + '/currencyReference';
        this.httpClient.get<any>(url).subscribe({
            next: (result) => {
                if (tthis && callback)
                    callback(tthis, result);
            },
            error: (error) => {
                callbackError(tthis, error);
            }
        });
    }
}
